// extracted by mini-css-extract-plugin
export default {"messageContainer":"Notifications_messageContainer__Pn8cf","dash":"Notifications_dash__dG6Ng"};